import { render } from "./TeamRow.vue?vue&type=template&id=78b1dc98&ts=true"
import script from "./TeamRow.vue?vue&type=script&lang=ts"
export * from "./TeamRow.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__